export const palette = {
  // Here is where you can define your own palette colors according to your Figma TSL Design Systems.
  // You can always use some default palette from Mui's palette importing correspondent color from '@mui/material/colors'
  // Check https://mui.com/material-ui/customization/color/ for more info.

  primary: {
    main: '#009CD8',
    light: '#98D8F1',
    dark: '#10598E',
    50: '#EEFAFF',
    100: '#CFEDFA',
    200: '#98D8F1',
    300: '#57C0E9',
    400: '#19ABE4',
    500: '#009CD8',
    600: '#0F6FA6',
    700: '#10598E',
    800: '#074979',
    900: '#003464',
    A100: '#82F8FF',
    A200: '#44DDFF',
    A400: '#29B2FF',
    A700: '#298BFF',
  },

  surface: {
    main: '#CDD9E0',
    light: '#FFFFFF',
    dark: '#25262E',
    50: '#FFFFFF',
    100: '#F5F9FC',
    200: '#E1E9EE',
    300: '#CDD9E0',
    400: '#AFBCC4',
    500: '#8895A0',
    600: '#62707C',
    700: '#3D4852',
    800: '#25262E',
    900: '#1C1B22',
    A100: '#FFFFFF',
    A200: '#B7CCE1',
    A400: '#252A30',
    A700: '#000000',
    A900: '#000000',
  },

  error: {
    main: '#F44336',
    light: '#E57373',
    dark: '#D32F2F',
    50: '#FFEBEE',
    100: '#FFCDD2',
    200: '#EF9A9A',
    300: '#E57373',
    400: '#EF5350',
    500: '#F44336',
    600: '#E53935',
    700: '#D32F2F',
    800: '#C62828',
    900: '#B71C1C',
    A100: '#FF8A80',
    A200: '#FF5252',
    A400: '#FF1744',
    A700: '#D50000',
  },

  warning: {
    main: '#FF9800',
    light: '#FFB74D',
    dark: '#F57C00',
    50: '#FFF300',
    100: '#FFE0B2',
    200: '#FFCC80',
    300: '#FFB74D',
    400: '#FFA726',
    500: '#FF9800',
    600: '#FB8C00',
    700: '#F57C00',
    800: '#EF6C00',
    900: '#FFDFB0',
    A100: '#FFD180',
    A200: '#FFAB40',
    A400: '#FF9100',
    A700: '#FF6B00',
  },

  success: {
    main: '#4CAF50',
    light: '#81C784',
    dark: '#388E3C',
    50: '#1C3122',
    100: '#25492A',
    200: '#2E6032',
    300: '#37783B',
    400: '#409044',
    500: '#4CAF50',
    600: '#5EC362',
    700: '#6ED472',
    800: '#84EC88',
    900: '#B7FDBA',
    A100: '#B9F6CA',
    A200: '#69F0AE',
    A400: '#00E676',
    A700: '#00C853',
  },

  info: {
    main: '#2196F3',
    light: '#2C609E',
    dark: '#6DBFFB',
    50: '#1D293E',
    100: '#1F335A',
    200: '#264C84',
    300: '#2C609E',
    400: '#3380C7',
    500: '#2196F3',
    600: '#57ABF8',
    700: '#6DBFFB',
    800: '#8ACEFF',
    900: '#CCE7FF',
    A100: '#82B1FF',
    A200: '#448AFF',
    A400: '#2979FF',
    A700: '#2962FF',
  },
}